import React, {useEffect, useState} from 'react';
import styles from './MatchesTable.module.css';
import {
    renderMatchResult,
    checkIfResultsEntered,
    renderPlayerName, formatFirstLetterOfName, renderPartnerName,
} from "../../../utils";
import {getUserData} from "../../../api/api"; // Make sure to have this CSS module

const MatchesTable = ({matches, onEditMatch, isArchived}) => {
    const [userData, setUserData] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            const data = await getUserData();
            setUserData(data);
        };
        fetchData();
    }, []);

    const canUserEditMatch = (match) => {
        // Check if the user is logged in and has the necessary role or is a participant of the match
        const userRoles = new Set(userData.authorities || []);
        const isUserAdminOrViewer = userRoles.has("ROLE_ADMIN") || userRoles.has("ROLE_EDITOR");
        const isUserParticipant = match.userId1 === userData.id || match.userId2 === userData.id || match.userId1Partner === userData.id || match.userId2Partner === userData.id;

        return isUserAdminOrViewer || isUserParticipant;
    };

    return (
        <div className={styles.container}>
            <h5 className={styles.title}>Mecze</h5>
            <table className={styles.table}>
                <tbody>
                {matches.map((match, index) => (
                    <tr key={match.id}>
                        <td>{index + 1}</td>
                        <td className={styles.playerNames}>
                            <div>
                                {renderPlayerName(match.participant1Id, match.participant1LastName, match.participant1FirstName, match)}
                                {match.participant1PartnerLastName && (
                                    <>
                                        <br/>
                                        <span
                                            className={styles.partnerName}>{renderPartnerName(match.participant1Id, match.participant1PartnerLastName, match.participant1PartnerFirstName, match )}</span>
                                    </>
                                )}
                            </div>
                            <div>
                                {renderPlayerName(match.participant2Id, match.participant2LastName, match.participant2FirstName, match)}
                                {match.participant2PartnerLastName && (
                                    <>
                                        <br/>
                                        <span
                                            className={styles.partnerName}>{renderPartnerName(match.participant2Id, match.participant2PartnerLastName, match.participant2PartnerFirstName, match )}</span>
                                    </>
                                )}
                            </div>
                        </td>
                        <td>
                            {match.setResults && renderMatchResult(match.setResults)}
                        </td>
                        <td>
                            {!isArchived && canUserEditMatch(match) && (
                                <button className={styles.button} onClick={() => onEditMatch(match.id)}>
                                    {checkIfResultsEntered(match) ? 'ED' : 'DO'}
                                </button>
                            )}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default MatchesTable;
